module.exports = __webpack_public_path__ + "static/media/Kofi.c6acc481.jpg";